import React, { Component } from "react";
import ProjectService from "../service/projectService";
import "../design/project.css";
import TaskStatusService from "../service/taskStatusService";
import NavigationBar from "../components/navigationBar";

export default class Project extends Component {

    constructor(props) {
        super(props);

        this.projectService = new ProjectService();
        this.taskStatusService = new TaskStatusService();

        this.state =
        {
            project: {},
            taskStatuses: [],
            selectedStatus: ""
        }

        this.handleChange = this.handleChange.bind(this);

    }

    componentDidMount() {
        document.title = "Project Detailed";
        this.getProjectDetailed();
        this.getTaskStatus();
    }

    async getTaskStatus() {
        let result = await this.taskStatusService.getTaskStatuses();

        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                taskStatuses: result
            })
        }
    }

    async getProjectDetailed() {
        let result = await this.projectService.getProjectInDetail(this.props.match.params.projectID);

        if (result.status === 401) {
            this.props.history.push("/Login");
        }
        else {
            this.setState({
                project: result
            })
        }
    }

    handleChange(event) {
        console.log(event);
        this.setState({
            selectedStatus: event.target.value
        });
    }

    render() {
        const project = this.state.project;
        if (!project) return null;
        const taskStatuses = this.state.taskStatuses;
        if (!taskStatuses) return null
        let owner;
        if (this.state.project.projectOwner != null) {
            owner = <p>{this.state.project.projectOwner.userName}</p>
        }
        else {
            owner = <p>This project have no owner </p>
        }

        return (
            <div className="body">
                <NavigationBar {...this.props} />
                <main>
                    <p>{this.state.project.projectName}</p>
                    <p>{this.state.project.createdOn}</p>
                    <p>{this.state.project.lastUpdated}</p>
                    {owner}
                    <select name="taskStatus" id="selectedStatus" onChange={this.handleChange} value={this.state.selectedStatus}>
                        <option disabled={true} value={""}> -- select an option -- </option>
                        {taskStatuses.map(taskstatusloop => (
                            <option value={taskstatusloop.taskStatusID} key={taskstatusloop.taskStatusID}>{taskstatusloop.statusName}</option>
                        ))}
                    </select>
                    <button onClick={() => { this.props.history.push("/Project/" + this.props.match.params.projectID + "/Tasks/Status/" + this.state.selectedStatus) }} className="button" >Go To tasks with selected Status</button>
                </main>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/sites/project.js